<template>
  <v-app class="feedback-app" lang="fa" dir="rtl"><router-view /></v-app>
</template>

<script>
// Provides Vuetify's application/dialog context without bootstrapping a user session.
export default {
  name: 'FeedbackShell',
  beforeCreate() {
    // Both language routes use the Persian form without changing the dashboard.
    // FeedbackScale provides its own LTR context for the rating lines.
    this.$vuetify = Object.create(this.$vuetify, { rtl: { value: true } })
  }
}
</script>

<style>
.feedback-app.v-application,
.feedback-app.v-application :not(.v-icon) {
  font-family: 'YekanBakh', Tahoma, sans-serif !important;
  letter-spacing: 0 !important;
}
.feedback-app.v-application {
  color: #213c35;
  font-size: 16px;
  line-height: 1.8;
  -webkit-font-smoothing: antialiased;
}
.feedback-app button,
.feedback-app input {
  font: inherit;
}
.feedback-app .v-btn {
  text-transform: none;
}
</style>
